var map = {
	"./Features-Block-Navigate-DA-DK-D.avif": 52193,
	"./Features-Block-Navigate-DE-DE-D.avif": 68950,
	"./Features-Block-Navigate-EN-GB-D.avif": 54371,
	"./Features-Block-Navigate-EN-US-D.avif": 27850,
	"./Features-Block-Navigate-ES-ES-D.avif": 23799,
	"./Features-Block-Navigate-ES-MX-D.avif": 5455,
	"./Features-Block-Navigate-FR-FR-D.avif": 85832,
	"./Features-Block-Navigate-IT-IT-D.avif": 55490,
	"./Features-Block-Navigate-NB-NO-D.avif": 12252,
	"./Features-Block-Navigate-NL-NL-D.avif": 93715,
	"./Features-Block-Navigate-PL-PL-D.avif": 44022,
	"./Features-Block-Navigate-PT-BR-D.avif": 25573,
	"./Features-Block-Navigate-PT-PT-D.avif": 11488,
	"./Features-Block-Navigate-SV-SE-D.avif": 88098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59713;